import React, {Component} from 'react'
import {message, Tooltip} from 'antd'
import PropTypes from 'prop-types'
import {markDone} from "../../../../../services/api/3dApi"

class MarkAsDone extends Component {
    _handleClick = e => {
        e.preventDefault()

        this._rqMarkDone()
    }

    _rqMarkDone = async () => {
        try {
            const {orderId} = this.props

            const {data: response} = await markDone(orderId)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.props.onSuccess('done')
        } catch (e) {
            message.error(e.message, 3)
        }
    }

    render() {
        return (
            <div className='MarkAsDone Icon'>
                <div className='d-inline-block' onClick={this._handleClick}>
                    <Tooltip title='Đánh dấu đã xong' placement='bottom'>
                        <i className='fa fa-check-square'/>
                    </Tooltip>
                </div>
            </div>
        )
    }
}

MarkAsDone.propTypes = {
    orderId: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
}

export default MarkAsDone
